import React from 'react'
import { Grid, Typography, TextField } from '@the-platform-group/component-library'

const SearchInput = ({
  label,
  value,
  onChange,
  disabled,
  error,
  helperText,
  placeholder = 'Enter UUID',
  children,
  isMultiJobStep,
}) => {
  return (
    <Grid item container xs={5} direction="column" spacing={2}>
      <Grid item>
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
          {label}
        </Typography>
        {!isMultiJobStep && (
          <TextField
            placeholder={placeholder}
            value={value}
            onChange={e => onChange(e.target.value)}
            disabled={disabled}
            fullWidth
            variant="outlined"
            error={!!error}
            helperText={helperText}
          />
        )}
      </Grid>
      {children}
    </Grid>
  )
}

export default SearchInput
